import { v4 as uuidv4 } from 'uuid'
// 生成唯一id
export function getUuid () {
  const uuidStr = uuidv4()
  return uuidStr
}
